import { styled } from "@mui/material/styles";
import { AppBar, Box, useMediaQuery, useTheme } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./Button";
import { NavLink } from "./NavLink";

const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "istransparent",
})<{ istransparent?: boolean }>(({ istransparent = true }) => ({
  background: istransparent ? "transparent" : "var(--brand-primary)",
  boxShadow: "none",
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1000,
}));

const HeaderContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  maxWidth: "1440px",
  margin: "0 auto",
  padding: " 0 120px",
  height: "75px",
  "@media (max-width: 600px)": {
    padding: " 0 16px",
  },
}));

const LogoWrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  textDecoration: "none",

  "& a": {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
  },
}));

const Navigation = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "30px",

  [theme.breakpoints.down("lg")]: {
    display: "none",
  },

  "& a": {
    color: "#ffffff",
    textDecoration: "none",
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    fontWeight: 400,

    transition: "opacity 0.2s",
    "&:hover": {
      opacity: 0.8,
      textDecoration: "none",
    },
    "&.active": {
      fontWeight: 500,
    }
  }
}));

const ButtonsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",

  [theme.breakpoints.down("lg")]: {
    "& .desktop-buttons": {
      display: "none",
    },
  },
}));

const MobileMenuButtonWrapper = styled(Box)(({ theme }) => ({
  display: "none",

  [theme.breakpoints.down("lg")]: {
    display: "flex",
  },
}));

const DesktopButtonsContainer = styled(Box)(() => ({
  display: "flex",
  gap: "12px",
}));

interface HeaderProps {
  onMenuClick?: () => void;
  transparent?: boolean;
}

export const Header = ({ onMenuClick, transparent = true }: HeaderProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const logoMap: Record<string, string> = {
    "/wallet": "/assets/logo-wallet.svg",
    "/business": "/assets/logo-business.svg",
    "/invest": "/assets/logo-invest.svg",
  };
  const currentLogo = logoMap[location.pathname] || "/assets/logo.svg";

  return (
    <StyledAppBar istransparent={transparent}>
      <HeaderContainer>
        <LogoWrapper>
          <Link to="/">
            <img
              src={currentLogo}
              alt="Сфера"
            />
          </Link>
        </LogoWrapper>

        <Navigation>
          <NavLink to="/wallet" active={isActive("/wallet")}>
            Сфера Кошелек
          </NavLink>
          <NavLink to="/business" active={isActive("/business")}>
            Сфера Бизнес
          </NavLink>
          <NavLink to="/invest" active={isActive("/invest")}>
            Сфера Инвест
          </NavLink>
          <NavLink to="/contacts" active={isActive("/contacts")}>
            Контакты
          </NavLink>
        </Navigation>

        <ButtonsContainer>
          {isMobile ? (
            <MobileMenuButtonWrapper>
              <Button variant="outline" onClick={onMenuClick}>
                Меню
              </Button>
            </MobileMenuButtonWrapper>
          ) : (
            <DesktopButtonsContainer className="desktop-buttons">
              <Button
                variant="outline"
              // onClick={() => window.open('https://', '_blank', 'noopener,noreferrer')}
              >
                Войти
              </Button>
              <Button
                variant="white"
              // onClick={() => window.open('https://', 'noopener,noreferrer')}
              >
                Демо
              </Button>
            </DesktopButtonsContainer>
          )}
        </ButtonsContainer>
      </HeaderContainer>
    </StyledAppBar>
  );
};
